import type { AllTokens } from "../../domain/entities/AllTokens";
import type { EnableTotp } from "../../domain/entities/EnableTotp";
import type { EnableTotpRepository } from "../../domain/repositories/EnableTotpRepository";
import { TotpApi } from "../api/TotpApi";

export class EnableTotpRepositoryImpl implements EnableTotpRepository {
  private totpApi = new TotpApi();

  async verifyTotpSetup(
    access_token: string,
    totp_code: string,
  ): Promise<EnableTotp> {
    return await this.totpApi.enableTotp(access_token, totp_code);
  }

  async verifyTotp(
    email: string,
    totp_code: string,
    purpose: string,
    access_token: string,
  ): Promise<AllTokens> {
    return await this.totpApi.verifyTotp(email, totp_code, purpose, access_token);
  }

  async resetTotp(temp_access_token: string) {
    return await this.totpApi.resetTotp(temp_access_token);
  }

  async sendEmailTotp(
    email: string,
    purpose: string,
    bearer_token?: string,
  ): Promise<number> {
    return this.totpApi.sendEmailTotp(email, purpose, bearer_token);
  }

  async verifyOtp(
    email: string,
    totp_code: string,
    purpose: string,
    bearer_token?: string,
  ): Promise<AllTokens> {
    return await this.totpApi.verifyOtp(email, totp_code, purpose, bearer_token);
  }
}
